import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

function Loading(props) {
  return (
    <CSSTransitionGroup
    className="container"
    component="div"
    transitionName="fade"
    transitionEnterTimeout={2000}
    transitionLeaveTimeout={1500}
    transitionAppear
    transitionAppearTimeout={1500}
    >
    <div className="container-btn result-container">
        <h1 className="result-heading text-center">
            Loading...
        </h1>
        <div className="progress">
            <div className="progress-bar progress-bar-striped bg-warning progress-bar-animated loading" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
    </CSSTransitionGroup>
  );
}

Loading.propTypes = { };

export default Loading;